import styled from "styled-components";
import { colors } from "definitions";

// Container del Confirmation: bg neutro, sin shadows ni radius propios
// (eso lo da el Modal). Padding solo para los botones del bottom.
export const Container = styled.div`
	background-color: #f6f7f9;
	width: 100%;
	text-align: center;
	font-weight: 600;
	line-height: 1.5;
`;

// Message: se extiende hasta los bordes del modal (el Modal hace clip).
// Padding generoso interno para que el texto no quede pegado al borde.
export const Message = styled.label`
	background-color: ${({ type }) =>
		type === "cancel"
			? `${colors.background.red}`
			: `${colors.background.navy}`};
	text-align: center;
	font-size: 2rem;
	padding: 3rem 2.4rem;
	justify-content: center;
	align-items: center;
	display: flex;
	color: ${colors.fonts.white};
	margin: 0;
	width: 100%;
	box-sizing: border-box;
`;

export const Options = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 1.6rem;
	padding: 2.4rem;
`;

export const Block = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;
